import Image from 'next/image';

import { Box, Button, Divider, Link, List, ListItem, Text } from '@chakra-ui/react';

import { ContentContainer } from '~/components/container';
import { trackEvent } from '~/features/analytics/track-event';
import { useBaseUrl } from '~/hooks/use-base-url';

export function ShareBar({ onDownloadPdfClick }: { onDownloadPdfClick: () => void }) {
  const shareUrl = useBaseUrl();
  const twitterShareText = 'Check out this case study from Udacity!';
  const hashtags = ['udacity', 'casestudy'].join(',');

  const socialMediaLinks = [
    {
      id: 'facebook',
      iconSrc: '/images/social/udacity-facebook-icon.svg',
      href: `https://www.facebook.com/sharer/sharer.php?display=popup&u=${shareUrl}`,
      label: 'Share on Facebook',
      track: () =>
        trackEvent({
          type: 'click',
          name: 'Enterprise CTA Clicked',
          label: 'Share This Case Study - Facebook',
          action: 'share_case_study_clicked',
        }),
    },
    {
      id: 'twitter',
      iconSrc: '/images/social/udacity-x-icon.svg',
      href: `https://twitter.com/intent/tweet?text=${twitterShareText}&url=${shareUrl}&hashtags=${hashtags}`,
      label: 'Share on X',
      track: () =>
        trackEvent({
          type: 'click',
          name: 'Enterprise CTA Clicked',
          label: 'Share This Case Study - Twitter',
          action: 'share_case_study_clicked',
        }),
    },
    {
      id: 'linkedin',
      iconSrc: '/images/social/linkedin.svg',
      href: `https://www.linkedin.com/sharing/share-offsite/?url=${shareUrl}`,
      label: 'Share on LinkedIn',
      track: () =>
        trackEvent({
          type: 'click',
          name: 'Enterprise CTA Clicked',
          label: 'Share This Case Study - LinkedIn',
          action: 'share_case_study_clicked',
        }),
    },
  ];

  return (
    <Box backgroundColor='accent.sky.100'>
      <ContentContainer>
        <Box alignItems='center' display='flex' flexDirection={{ base: 'column', sm: 'row' }} paddingY='16px'>
          <Box alignItems='center' display='flex' gap='16px'>
            <Text fontSize='14px' fontWeight='600'>
              Share This Case Study
            </Text>

            <Divider
              borderColor='black'
              borderWidth='2px'
              boxSizing='border-box'
              maxWidth='56px'
              minWidth='24px'
              opacity='1'
              width={{ base: 'auto', sm: '56px' }}
            />

            <List display='flex' gap='16px'>
              {socialMediaLinks.map((link) => (
                <ListItem key={link.id} onClick={link.track}>
                  <Link href={link.href} isExternal={true}>
                    <Image alt={link.label} color='red' height={32} src={link.iconSrc} width={32} />
                  </Link>
                </ListItem>
              ))}
            </List>
          </Box>

          <Button
            marginLeft='auto'
            marginRight={{ base: 'auto', sm: 'unset' }}
            marginTop={{ base: '16px', sm: 'unset' }}
            variant='ghost'
            onClick={onDownloadPdfClick}
          >
            Download PDF
          </Button>
        </Box>
      </ContentContainer>
    </Box>
  );
}
